import React from 'react'

function ItemPartner({id, position, srcLogo, altLogo}) {
  return (
    <div style={{'--position': position,}} className="item flex-center">
        <img id={id} src={srcLogo} alt={altLogo} width="130" height="95"/>
    </div>
  )
}

export default ItemPartner
